//Funcion para separar el input de la direccion en variables addressLine dependiendo de su longitud
export function splitAddress(content: string): [string, string, string] {
  let addressLine1: string = "";
  let addressLine2: string = "";
  let addressLine3: string = "";

  const words = content.split(" ");

  for (const word of words) {
    if (addressLine1.length + word.length <= 45) {
      addressLine1 += word + " ";
    } else if (addressLine2.length + word.length <= 45) {
      addressLine2 += word + " ";
    } else {
      addressLine3 += word + " ";
    }
  }

  addressLine1 = addressLine1.trim();
  addressLine2 = addressLine2.trim();
  addressLine3 = addressLine3.trim();

  return [addressLine1, addressLine2, addressLine3];
}
